import TokenTable from '../../components/Token/TokenTable';

export default function TokenList() {
	return <TokenTable />;
}
